export default {
  coordinates: "GPS Coordinates",
  timezone: "Timezone",
  invalid_timezone: "Invalid Zone",
  active_work_orders: "Active Work Orders",
  open_issues: "Open Issues",
  adhoc_discovery: "Ad-hoc discovery",
  work_order_discovery: "Work Order discovery",
  pending_corrective_work: "Pending Corrective Work",
  median_correction_time: "Median Correction Time",
  days: "days",
  deadline_label: "Deadline for Correction",
  admins: "Administrators",
  more: "More...",
}
